<template lang="pug">
#safety-confirm-register-confirm
  // title
  .d-flex.flex-row.justify-content-center.mb-2
    .page-title 安否確認の新規作成

  // progress
  ProcessIndicator(v-model="indicator")
  .mb-3.separator

  // title
  .mb-0
    span.key-name タイトル
  #title.mb-3
    .mb-0
      span {{ name }}

  // buttons
  .d-flex.flex-row.justify-content-center
    b-button.btn.register-btn.mr-2(@click="onRegister") 登録
    b-button.btn.back-btn(@click="onCancel") 戻る

  // loading component
  Loading(:isBusy="isBusy", :message="loadingMessage")
</template>

<script lang="ts">
import { Component, Inject, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { userStore, mobileSafetyConfirmRegisterStore } from "@/store/store";
import { MobileSafetyConfirmRegisterState } from "@/store/MobileSafetyConfirmRegister";
import { MobileUrl } from "@/commons/constants/MobileUrl";

import SafetyConfirmsService, { SafetyConfirmsPostModel } from "@/commons/services/SafetyConfirms";

import Loading from "@/mobile/basics/Loading.vue";
import ProcessIndicator, { ProcessIndicatorModel } from "@/mobile/basics/ProcessIndicator.vue";

/**
 * ### 安否確認 登録情報 確認コンポーネント
 */
@Component({
  components: {
    Loading,
    ProcessIndicator
  }
})
export default class SafetyConfirmRegisterConfirm extends Vue {
  /** 安否確認サービス */
  @Inject("SafetyConfirmsService") safetyConfirmsService!: SafetyConfirmsService;

  /** ### 新規送信入力画面での入力情報 */
  @Getter("mobileSafetyConfirmRegisterState") state!: MobileSafetyConfirmRegisterState;

  /** インジケータ */
  indicator: Array<ProcessIndicatorModel> = [
    { text: "入力", current: false },
    { text: "確認", current: true },
    { text: "完了", current: false }
  ];

  /** 読み込み中モーダル表示可否 */
  isBusy: boolean = false;
  /** 読み込み中モーダルメッセージ */
  loadingMessage: string = "読込み中";

  /** 安否確認名 */
  name: string = "";

  /**
   * ### vue lifecycle mounted
   */
  public async mounted(): Promise<void> {
    // ブラウザバック対応。メッセージ送信後にブラウザバックされた場合にstoreに内容がないため表示する内容が無い
    // storeがリセットされていたら入力画面へ遷移させる
    if (this.state.exist == false) {
      this.$router.push(MobileUrl.SafetyConfirmRegisterInput);
    }

    await this.createView();
    return;
  }

  /**
   * ### 画面表示情報を作成する
   */
  public async createView(): Promise<void> {
    this.isBusy = true;

    this.name = this.state.name;

    this.isBusy = false;

    return;
  }

  /**
   * ### 登録ボタン押下イベント
   *
   * - 安否確認を登録する
   * - 安否確認登録完了画面へ遷移する
   */
  public async onRegister(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "登録中";

    const requestBody: SafetyConfirmsPostModel = { name: this.name };
    await this.safetyConfirmsService.post(userStore, requestBody);

    mobileSafetyConfirmRegisterStore.resetMobileSafetyConfirmRegisterState();
    this.$router.push(MobileUrl.SafetyConfirmRegisterComplete);

    return;
  }

  /**
   * ### 戻るボタン押下イベント
   *
   * - 安否確認 登録情報 入力画面へ遷移する
   */
  public onCancel(): void {
    this.$router.push(MobileUrl.SafetyConfirmRegisterInput);
    return;
  }
}
</script>

<style lang="scss" scopeed>
#safety-confirm-register-confirm {
  #title {
    white-space: pre-wrap;
    word-wrap: break-word;
  }
  .register-btn,
  .back-btn {
    min-width: 84px;
  }
}
</style>
